// Modular exponentiation (base^exp % mod)
function modExp(base, exp, mod) {
    let result = 1n;
    let b = BigInt(base);
    let e = BigInt(exp);
    let m = BigInt(mod);

    while (e > 0n) {
        if (e % 2n === 1n) {
            result = (result * b) % m;
        }
        b = (b * b) % m;
        e = e / 2n;
    }
    return result;
}



// RSA encrypt: ciphertext = (plaintext^e) mod n
export function rsaEncryptKey(aesKey, e, n) {
    const plaintext = BigInt("0x" + aesKey);
    const eInt = BigInt(e);
    const nInt = BigInt(n);

    const encrypted = modExp(plaintext, eInt, nInt);

    // compute modulus size in hex digits
    const modulusHexLen = nInt.toString(16).length;


    // pad encrypted key to modulus size
    console.log("//////)");
    console.log( "encrypted aeskey with rsa",encrypted.toString(16).padStart(modulusHexLen, "0"));
    return encrypted.toString(16).padStart(modulusHexLen, "0");
}

// RSA decrypt: plaintext = (ciphertext^d) mod n
export function rsaDecryptKey(currentPrivateKey, d, n) {
    const cipherInt = BigInt("0x" + currentPrivateKey);
    const dInt = BigInt(d);
    const nInt = BigInt(n);

    const decrypted = modExp(cipherInt, dInt, nInt);

    // AES-128 key is always 16 bytes = 32 hex characters

    console.log("decrypted aes key with rsa",decrypted.toString(16).padStart(32, "0"));  
    return decrypted.toString(16).padStart(32, "0");
    
}
